import styled from "styled-components";

export const ContainerInputs = styled.div`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  width: 100% !important;
  @media (max-width: 750px) {
    align-items: center !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
`;

export const ContainerTitleSync = styled.div`
  align-items: flex-start !important;
  display: flex !important;
  @media (max-width: 750px) {
    align-items: center !important;
  }
`;
